import { useQuery } from 'react-query';
import CardRelatorio from '../CardRelatorio';
import axios from 'axios';
import Skeleton from '../../../components/layout/Skeleton';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { currencyFormat } from './util';

type Props = {
  dataInicio: string;
  dataFim: string;
};

const CardDespesasPorCategoria = ({ dataInicio, dataFim }: Props) => {
  const q = useQuery(
    ['financeiroDespesasPorCategoria', dataInicio, dataFim],
    async () => {
      const qs = new URLSearchParams();
      qs.append('facts', 'total_saidas');
      qs.append('dimensions', 'categoria');
      qs.append(
        'filter',
        JSON.stringify({ data_inicio: dataInicio, data_fim: dataFim, tipo: 'despesa' }),
      );

      const res = await axios.get(
        '/api/relatorios/lancamento_financeiro?' + qs.toString(),
      );
      // O pg retorna sum() de numeric como string; o Recharts precisa de
      // number no eixo, senão todas as barras saem com largura máxima.
      return (res.data.result as any[])
        .map(r => ({ ...r, total_saidas: +r.total_saidas }))
        .sort((a, b) => b.total_saidas - a.total_saidas)
        .slice(0, 8);
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio titulo="Despesas por categoria" style={{ height: '420px' }}>
      {q.isFetching ? (
        <Skeleton format="box" />
      ) : (
        <ResponsiveContainer width="100%" height={320}>
          <BarChart
            data={q.data}
            layout="vertical"
            margin={{ top: 5, right: 20, left: 5, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" tickFormatter={v => currencyFormat.format(v)} />
            <YAxis type="category" dataKey="categoria" width={120} />
            <Tooltip formatter={(v: any) => currencyFormat.format(+v)} />
            <Bar dataKey="total_saidas" name="Despesas" fill="#7339ac" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </CardRelatorio>
  );
};

export default CardDespesasPorCategoria;
